<template>
  <div class="header__search" :class="searchOpen ? 'header__search--active' : ''">
        <div class="header__search__container">
          <div class="header__image-wrapper">
            <a href="/">
              <span class="site-header__image">
                <header-logo @click="toggleSearch" />
              </span>
            </a>
          </div>
          <form class="header__search-form" data-children-count="1" @submit.prevent="submitSearch">
            <span class="site-search-icon">
              <search-icon/>
            </span>
            <label for="site-search" class="sr-only">{{ $t('search.placeholder') }}</label>
            <input type="text"
              id="site-search"
              :placeholder="$t('search.placeholder')"
              v-model="searchTerm"/>
            <button id="site-search--button" type="submit">{{ $t('search.cta') }}</button>
          </form>
          <div class="header__search-close">
            <button class="search-close" @click="toggleSearch">
              <font-awesome-icon icon="times"/>
            </button>
          </div>
        </div>
      </div>
</template>

<script>
import SearchIcon from "@/components/layout/header/icons/SearchIcon"
import HeaderLogo from "@/components/layout/header/icons/HeaderLogo"

export default {
  name: 'header-search',
  data() {
    return {
      searchTerm: ""
    }
  },
  components: {
    SearchIcon, 
    HeaderLogo
  },
  props: {
    searchOpen: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggleSearch() {
      this.$emit('toggleSearch')
    },
    submitSearch() {
      window.location = process.env.VUE_APP_WK_FRONT_END_URL + "/" + this.$i18n.locale + "/search?searchTerm=" + this.searchTerm + "&siteUuid=Main"
    }
  },
}
</script>

<style>

</style>